module.exports = __webpack_public_path__ + "pic/12.46a9fbfd.png";